import { createSelector } from 'reselect'
import moment from 'moment'
import { selectFromCurrentCELs } from './dictionary'

const ANSWER_KEYS = ['homeFactsCorrect', 'homeUpdated', 'isEstimateCorrect']

export const selectHasCMA = selectFromCurrentCELs('cmaDone')
export const selectPreviousREA = selectFromCurrentCELs('sellingAgent')

const getHasRecentlyRequested = home => {
  const { hasRequestedCma: cmaDate } = home || {}
  const lastYear = moment().subtract(1, 'year')
  return cmaDate && moment(cmaDate).isAfter(lastYear)
}

export const selectHasRecentlyRequested = createSelector(
  state => state.home.data,
  getHasRecentlyRequested
)

const getHasCompletedQuestions = home =>
  ANSWER_KEYS.every(key => home.answers[key])

export const selectHasCompletedQuestions = createSelector(
  state => state.home.data,
  getHasCompletedQuestions
)

const getCMAFlowInitialStep = (recentlyRequested, completedQuestions) => {
  if (recentlyRequested) {
    return completedQuestions ? 'complete' : 'estimateCorrectness'
  }
  return 'start'
}

export const selectCMAFlowInitialStep = createSelector(
  selectHasRecentlyRequested,
  selectHasCompletedQuestions,
  getCMAFlowInitialStep
)
